import { VTooltip } from '@/types/vuetify/VTooltip'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
})
export default class SHint extends Vue {
  @Ref('tooltip') private readonly tooltipRef?: VTooltip

  @Prop({ type: Boolean, default: undefined })
  private readonly top?: boolean

  @Prop({ type: Boolean, default: undefined })
  private readonly bottom?: boolean

  @Prop({ type: Boolean, default: false })
  private readonly disabled!: boolean

  @Prop({ type: Number, default: 150 })
  private readonly closeDelay!: number

  @Prop({ type: Number, default: 150 })
  private readonly openDelay!: number

  @Prop({ type: Number })
  private readonly maxWidth?: number

  @Prop({ type: String })
  private readonly contentClass?: string

  private isTouchSupported = false

  private toggleTooltip(value?: boolean) {
    if (!this.tooltipRef) {
      return
    }

    value = value ?? !this.tooltipRef.isActive

    this.tooltipRef.isActive = value
  }

  private onClickActivator() {
    if (!this.isTouchSupported) {
      return
    }

    this.toggleTooltip()
  }

  private created() {
    this.$watch(
      () => {
        return this.$vuetify.breakpoint.width
      },
      () => {
        this.isTouchSupported = navigator.maxTouchPoints > 0
      },
      {
        immediate: true,
      }
    )
  }

  private mounted() {
    const onBodyClick = (event: Event) => {
      if (!this.tooltipRef?.isActive) {
        return
      }

      const targetEl = event.target as HTMLElement | null
      const activatorEl = this.$el.nextElementSibling

      if (!targetEl || activatorEl?.contains(targetEl)) {
        return
      }

      this.toggleTooltip(false)
    }

    this.$watch(
      () => {
        return this.isTouchSupported
      },
      (isTouchSupported) => {
        this.toggleTooltip(false)

        if (isTouchSupported) {
          document.body.addEventListener('click', onBodyClick)
        } else {
          document.body.removeEventListener('click', onBodyClick)
        }
      },
      {
        immediate: true,
      }
    )

    this.$once('hook:beforeDestroy', () => {
      document.body.removeEventListener('click', onBodyClick)
    })
  }
}
